import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=65882a95&scoped=true"
import script from "./accountManage.vue?vue&type=script&lang=ts"
export * from "./accountManage.vue?vue&type=script&lang=ts"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=65882a95&prod&lang=scss&scoped=true"
import style1 from "./accountManage.vue?vue&type=style&index=1&id=65882a95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65882a95",
  null
  
)

export default component.exports